import { Product, ProductCasePack } from "@deliverr/business-types";

export function getDefaultCasePack(product: Product): ProductCasePack | undefined {
  return product.productCasePacks?.find((casePack) => casePack.isDefaultPack);
}

export function buildCasePackFromProduct(product: Product): ProductCasePack {
  const defaultCasePack = getDefaultCasePack(product);
  const quantity = (product.packOf ? product.caseQty : defaultCasePack?.quantity) ?? 1;

  return {
    dsku: product.dsku,
    packOf: product.packOf ?? product.dsku,
    quantity,
    isDefaultPack: false,
    weight: defaultCasePack?.weight ?? product.weight,
    weightUnit: defaultCasePack?.weightUnit ?? product.weightUnit,
    height: defaultCasePack?.height ?? product.height,
    width: defaultCasePack?.width ?? product.width,
    length: defaultCasePack?.length ?? product.length,
    lengthUnit: defaultCasePack?.lengthUnit ?? product.lengthUnit,
    packName: defaultCasePack?.packName,
  };
}
